export const resume = {
  name: 'Mike Moe',
  title: 'Software Engineer · Game Dev · Fullstack',
  location: 'Austin, TX',
  email: 'mikeroymoe@gmail.com',
  site: 'https://www.mike-moe.com',
  github: 'https://github.com/konlet',
  twitter: 'https://twitter.com/MikeMoeDev',
  twitterHandle: '@MikeMoeDev',
  summary:
    'Software engineer with a dual focus on gameplay systems and fullstack product work. I lead teams, write the docs people actually use, and ship polished interfaces across games, web, and tools.',
  experience: [
    {
      company: 'Surge',
      role: 'Software Engineer',
      duration: '2026-Present',
      points: [
        'Contribute software engineering across a variety of team-based projects.',
        'Collaborate with teams to ship features and systems from kickoff through delivery.'
      ]
    },
    {
      company: 'Zenimax',
      role: 'Game Developer',
      duration: '2025',
      points: [
        'Owned end-to-end gameplay systems, performance passes, and team mentorship.',
        'Architected core engine modules and tooling, then tightened frame times and asset pipelines.'
      ]
    },
    {
      company: 'Vylocity',
      role: 'Administration',
      duration: '2020-Present',
      points: [
        'Wrote about 100 pages of engine documentation and coached contributors through onboarding.',
        'Standardized templates and review so new developers reached productive work faster.'
      ]
    },
    {
      company: 'Google Fiber',
      role: 'Software Engineer',
      duration: '2018-2019',
      points: [
        'Shipped internal tools and resolved escalated technical issues with support partners.',
        'Improved tooling reliability and observability for day-to-day operations.'
      ]
    },
    {
      company: 'BYOND Software',
      role: 'Administration',
      duration: '2015-2019',
      points: [
        'Moderated community channels and produced tutorials and example projects.',
        'Raised community health through teaching, support, and consistent presence.'
      ]
    }
  ],
  education: [
    {
      title: 'Software Engineering, BS',
      place: 'Western Governors University',
      detail: 'Expected 2026'
    },
    {
      title: 'Front-End Developer',
      place: 'Western Governors University',
      detail: 'Technical certificate',
      href: 'https://wgu.badges.parchment.com/public/assertions/t2MQfH5-QBGhLAwR7eX3gQ?identity__email=mmoel23@wgu.edu'
    }
  ],
  skills: [
    { group: 'Game Dev', items: ['Gameplay systems', 'Engine tooling', 'Performance', 'Mods'] },
    { group: 'Fullstack', items: ['React', 'React Native', 'Node/Express', 'Vite'] },
    { group: 'Delivery', items: ['TypeScript', 'Cloud deploys', 'Accessibility', 'Documentation'] }
  ],
  projects: [
    {
      name: 'Spectreborne',
      tag: 'Game',
      href: 'https://konlet.itch.io/spectreborne',
      blurb: 'Lospec Jam 1 entry. First in art, tenth overall, and included on the jam virtual console.'
    },
    {
      name: 'RolePlay Infinite',
      tag: 'Game',
      href: 'https://konlet.itch.io/rpi',
      blurb: 'Retired text-based roleplaying app with characters, inventories, and forums, used by thousands.'
    },
    {
      name: 'Floorplan Pro',
      tag: 'Product',
      href: 'https://floorplan.pro/',
      blurb: 'Browser floorplan editor for rooms, floors, fixtures, and measurements without a CAD subscription.'
    },
    {
      name: 'Grain Rot Together',
      tag: 'Mod',
      href: 'https://github.com/Konlet/grain-rot-together',
      blurb: 'Unreal multiplayer expansion that raises lobby size past the vanilla four-player cap.'
    },
    {
      name: 'Crystal Clear',
      tag: 'Mod',
      href: 'https://github.com/Konlet/grain-rot-crystal-clear',
      blurb: 'Turns on Unreal’s unused microphone noise gate so proximity chat drops fans, AC, and keyboard rattle.'
    }
  ]
};
